// Availability feedback only; the theme's quantity input and cart remain in control.
if (!customElements.get('boa-quantity-availability')) {
  customElements.define('boa-quantity-availability', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const input = this.querySelector('input[name="quantity"]');
      const status = this.querySelector('[role="status"]');
      const initialMessage = status?.textContent;
      const maximum = input.max === '' ? Infinity : Number(input.max);
      const report = requested => {
        if (status) status.textContent = requested > maximum ? this.dataset.limitMessage : initialMessage;
      };
      const options = {capture: true, signal: this.controller.signal};
      this.addEventListener('click', event => {
        const button = event.target.closest('.quantity-selector__button');
        if (!button) return;
        const buttons = this.querySelectorAll('.quantity-selector__button');
        report(Number(input.value) + (button === buttons[buttons.length - 1] ? 1 : -1));
        // The native +/- buttons set the value without emitting a change event.
        queueMicrotask(() => input.dispatchEvent(new Event('change', {bubbles: true})));
      }, options);
      input.addEventListener('input', () => report(Number(input.value)), options);
      input.addEventListener('keydown', event => {
        if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
          report(Number(input.value) + (event.key === 'ArrowUp' ? 1 : -1));
          queueMicrotask(() => input.dispatchEvent(new Event('change', {bubbles: true})));
        }
      }, options);
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
